module.exports = __webpack_public_path__ + "static/media/13.85ea0b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/13.png
// module id = 379
// module chunks = 0